import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../themes'

const topBarHeight = 66
const pinCodeHeight = 52
const meetingInfoBoxPadding = 32
const buttonBoxHeight = 84

export const MeetingInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${COLOR.GRAY_5};

  .meeting-info__box__pin-code {
      height: ${pinCodeHeight - (15 * 2)}px;
      padding: 15px 24px;
      background-color: ${NATIVE_BASE_COLORS.TEXT[100]};
      display: flex;
      align-items: center;
      justify-content: center;

    p {
      margin: 0;
      font-size: ${FONT_SIZE.XXS};
      font-family: NunitoRegular;
    }
  }

  .meeting-info__box__detail {
    padding: ${meetingInfoBoxPadding}px ${meetingInfoBoxPadding}px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - ${topBarHeight + pinCodeHeight + (2 * meetingInfoBoxPadding)}px);
    position: relative;

    &__header {
      font-family: LibreBaskervilleBold;
      margin: 0;
    }

    &--top {
      display: flex;
      flex-direction: column;
      gap: 40px;
      height: 100%;
      overflow-y: scroll;
      height: calc(100% - ${buttonBoxHeight}px);

      ::-webkit-scrollbar {
        width: 0px;
      }
    }
    
    &--bottom {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 16px;
      height: ${buttonBoxHeight}px;
      width: 100%;
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 0 32px;
      border-top: 1px solid ${COLOR.GRAY_5};
      z-index: 3;
      background-color: ${COLOR.WHITE};

      button {
        min-width: 140px;
        height: 48px;
        padding: 8px 20px;
        border-radius: 4px;
        font-size: ${FONT_SIZE.XXS};
        font-family: NunitoRegular;
        text-align: center;
        cursor: pointer;
      }

      &__end-button {
        background: none;
        border: 1px solid ${COLOR.RED_3};
        color: ${COLOR.RED_3};
      }

      &__extend-button {
        border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
        background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
        color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : COLOR.BLACK}
      }
    }
  }

  .two-lines {
    display: flex;
    flex-direction: row;
    width: 70%;
    font-family: NunitoSansBold;
    color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
  }

  .two-lines a {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: -webkit-fill-available;
  }

  .text-inline {
    max-width: 460px;
  }

  .link-icon {
    text-decoration: none;
    color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
    }

  .copy-link-button {
    padding: 0;
    background-color: unset;
    border: unset;
    cursor: pointer;
  }
  
  .meeting-info__box__actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .meeting-info__box__edit-button {
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoRegular;
    border: 1px solid ${NATIVE_BASE_COLORS.PRIMARY[300]};
    color: ${NATIVE_BASE_COLORS.PRIMARY[300]};
    background: none;
    border-radius: 4px;
    min-height: 48px;
    cursor: pointer;
  }

  .content-body {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
    margin: 0 0 20px 0;
    line-height: 36px;
    min-height: 36px;
    outline: none;

  }

  .meeting-info__box__detail--bottom > .disabled {
    opacity: 0.24;
    cursor: unset;
  }
`

export const DropdownStyled = styled.div`
   .content-body {
    display: flex;

  }

   .number-input {
    flex: 1;
  }

  .notification-list {

    min-width: 336px;
    height: 44px;
  }
  .notification-list > .dropdown-container > * {
    text-align: left;
  }

  .notification-list > label {
    height: unset;
    text-align: start;
    margin-left: 10px;
  }

  .content-body > .label-text {
    margin-left: unset;
  }

  .button-container {
    width: 34px;
    padding: 12px 10px;
  }
`
